import EMA from '../assets/js/singleton-ema'
import * as Common from '../assets/js/common.js'
import { mapState } from 'vuex'
import { loadJs } from './Util'

function setPageTitle (title) {
  if (window.navigator.userAgent.match(/DingTalk/i)) {
    // 钉钉走特殊的设置标题栏的方法
    loadJs('https://g.alicdn.com/dingding/dingtalk-jsapi/2.13.20/dingtalk.open.js').then(() => {
      window.dd.ready(() => {
        window.dd.biz.navigation.setTitle({ title })
      }).catch(() => {
      })
    }).catch(() => {
    })
  }

  document.title = title
}

export default {
  props: ['params'],
  data: function () {
    return {}
  },
  computed: mapState({
    Config: state => state.Config,
    RootNodeInfo: state => state.RootNodeInfo,
    Metadata: state => state.Metadata
  }),
  beforeCreate: function () {
  },
  created: function () {
    this.ema = EMA.getProxy()
    this.Common = Common
  },
  beforeMount: function () {
  },
  mounted: function () {
  },
  activated: function () {
    var me = this
    if (this.$options.pageName) {
      setPageTitle(this.$options.pageName)
    }
    this.$store.dispatch('setCurrentPage', me.$options.name) // 记录页面信息
  },
  deactivated: function () {
    window.loading('hide')
  },
  beforeDestroy: function () {
  },
  destroyed: function () {
    if (this.ema) {
      this.ema.dispose()
    }
  },

  methods: {
    setPageTitle: setPageTitle,
    /**
     * 组件内部范围绑定事件
     * @param key
     * @param fn
     */
    bindEvent: function (key, fn) {
      if (!this.$options.name) {
        console.warn('绑定事件的组件不存在组件名称', key)
      }
      this.ema.bind(`${this.$options.name}.${key}`, fn)
    }
  }
}
